// extracted by mini-css-extract-plugin
module.exports = {"seating__select":"styles_seating__select__wUc2F","seating__button":"styles_seating__button__3BvHT","seating__chevron":"styles_seating__chevron__314Og","open":"styles_open__JQbj7"};